import type { ComponentType } from "react";

let modulesPromise: Promise<{
  ConfigurationPage: ComponentType;
  ImportData: ComponentType;
  AttributeMapping: ComponentType;
}> | null = null;

const loadConfigurationRouteModules = async () => {
  try {
    const [{ ConfigurationPage }, { ImportData, AttributeMapping }] =
      await Promise.all([
        import("./ConfigurationPage"),
        import("./outlets/lazy"),
      ]);

    // ! DisplayOptions disabled for 26.1, until further notice
    modulesPromise ??= Promise.resolve({
      ConfigurationPage,
      ImportData,
      AttributeMapping,
    });

    return await modulesPromise;
  } catch (error) {
    modulesPromise = null;

    throw error;
  }
};

export { loadConfigurationRouteModules };
